import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  PortalProduct,
  PortalProductsQuery,
  PortalProductSubscription,
  Cart,
  CartQuery,
  CartService,
  PortalProductsSubscriptionsService,
} from '@fgb/core';
import { Observable, Subscription } from 'rxjs';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'fgb-subscriptions-list-item-renewals',
  templateUrl: './subscriptions-list-item-renewals.component.html',
  styleUrls: ['./subscriptions-list-item-renewals.component.scss'],
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [
        style({ height: '0', opacity: '0', overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: '1' })),
      ]),
      transition(':leave', [style({ overflow: 'hidden' }), animate('250ms ease-in', style({ height: '0', opacity: '0' }))]),
    ]),
  ],
})
export class SubscriptionsListItemRenewalsComponent implements OnInit, OnDestroy {
  @Input() subscribedProduct: PortalProductSubscription;
  items$: Observable<Cart[]>;
  currentLcid: string | null = '';
  noticePeriod: Date;
  currentDate: Date;
  withinRenewal: boolean = false;
  renewalProduct: PortalProduct;
  currentSubscribedProduct: PortalProductSubscription;
  itemSub: Subscription;
  isExpanded = false;
  autoRenewal = false;

  get daysLeft(): number {
    if (!this.currentSubscribedProduct?.NextPaymentDueDate) return 0;
    const diff = new Date(this.currentSubscribedProduct.NextPaymentDueDate).getTime() - Date.now();
    return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
  }

  constructor(
    private cartQuery: CartQuery,
    private portalProductsQuery: PortalProductsQuery,
    private cartService: CartService,
    private portalProductsSubscriptionsService: PortalProductsSubscriptionsService
  ) {
    this.currentLcid = localStorage.getItem('lcid');
  }

  ngOnInit() {
    this.items$ = this.cartQuery.selectAllSubscriptionCartData();
    this.updateStatus();
  }

  ngOnDestroy() {
    if (this.itemSub) {
      this.itemSub.unsubscribe();
    }
  }

  updateStatus() {
    if (this.subscribedProduct.ProductType === 1) {
      this.currentSubscribedProduct = this.subscribedProduct;
      this.autoRenewal = this.currentSubscribedProduct.AutoRenewalStatus;
      this.noticePeriod = new Date(this.currentSubscribedProduct.NextPaymentDueDate);
      this.noticePeriod.setDate(this.noticePeriod.getDate() - 30);
      this.currentDate = new Date();

      if (this.currentDate > this.noticePeriod) {
        this.withinRenewal = true;
        this.getRenewalProduct();
      }
    }
  }

  // get renewal product
  getRenewalProduct() {
    let renewalPortalProducts: PortalProduct[];
    renewalPortalProducts = this.portalProductsQuery.getAllProductsByProductType(8, undefined);
    for (let product of renewalPortalProducts) {
      // will add condition here to compare attribute ID with current product, once attributes added to response
      this.renewalProduct = product;
    }
  }

  // add renewal product to cart
  addRenewalProductToCart() {
    if (!this.checkBasketForRenewal()) {
      this.cartService.addPortalProductToCart(this.renewalProduct);
    }
  }

  // checks if product type 8 renewal portal product exists within basket
  checkBasketForRenewal(): boolean {
    let itemsInCart: Cart[] = [];
    this.itemSub = this.items$.subscribe((data) => {
      itemsInCart = data;
    });
    for (let product of itemsInCart) {
      if (
        product.productData.ProductType === 8 &&
        (product.productData as PortalProduct).ProductId === this.renewalProduct.ProductId
      ) {
        return true;
      }
    }
    return false;
  }

  toggleAutoRenewal() {
    const id = this.currentSubscribedProduct.SubscriptionId;
    if (this.autoRenewal) {
      this.portalProductsSubscriptionsService.deactivateSubscription(id).subscribe(() => {
        this.autoRenewal = false;
      });
    } else {
      this.portalProductsSubscriptionsService.activateSubscription(id).subscribe(() => {
        this.autoRenewal = true;
      });
    }
  }
}
